//Función para actualizar una sesión existente o nueva, agregando un nuevo mensaje entrante.
//Recibe como parámetros los datos del nuevo mensaje entrante, el array con las sesiones de ese chat y la función "setSessions" para actualizarlo.
export const newMessageEntry = (data, sessions, setSessions, chatData) => {
    if (sessions) {
        let index = sessions.findIndex(e => e.IdSession === data.IdMessageSession); //Indice con la posicion dentro del array de sesiones a la que pertenece el mensaje entrante.
        if (chatData.IdChat === data.IdChat) {
            if (index === -1) { //Si no encuentra ningun indice dentro del array de sesiones (no existe ninguna sesion con ese Id de Sesion).
                console.log('No encontre ninguna sesion que tenga ese id, creo una sesion nueva');

                setSessions(prevChat => { //Actualiza el array de sesiones incorporando la nueva sesion con su mensaje entrante.
                    return [...prevChat, {
                        Fin: null,
                        IdPlataforma: data.IdPlataforma,
                        IdSession: data.IdMessageSession,
                        Inicio: data.FechaHora,
                        Messages: [
                            {
                                Type: data.Type,
                                UrlFile: data.UrlFile,
                                IdMessage: data.IdMessage,
                                Message: data.Message,
                                Entrante: data.Entrante,
                                FechaHora: data.FechaHora,
                                Iniciales: data.Iniciales,
                            }]
                    }
                    ]
                });
            }
            else { //Si encuentra un indice (existe una sesion con ese Id de Sesion).
                console.log('Encontre una sesion que tenga ese id, voy a concatenear el mensaje');

                // Verifica si ya existe un mensaje con el mismo IdMessage en la sesión actual.
                const existingMessage = sessions[index].Messages.find(message => message.IdMessage === data.IdMessage);
                // Si no existe un mensaje con el mismo IdMessage, agrega el mensaje entrante a la sesión.
                console.log("hay un mensaje ****", existingMessage)
                if (!existingMessage) {

                    setSessions(prevChat => { //Actualiza el array de mensajes de esa sesion, incorporando el mensaje entrante.

                        const updatedChat = prevChat.map(session => {
                            if (session.IdSession === data.IdMessageSession) {
                                return {
                                    ...session,
                                    Messages: [...session.Messages,
                                    {
                                        Type: data.Type,
                                        UrlFile: data.UrlFile,
                                        IdMessage: data.IdMessage,
                                        Message: data.Message,
                                        Entrante: data.Entrante,
                                        FechaHora: data.FechaHora,
                                        Iniciales: data.Iniciales,
                                    }]
                                };
                            }
                            return session;
                        });
                        return updatedChat;
                    });
                }
            }
        }
    }
};